import styled from "styled-components";

const Container = styled.div`
  padding-left: 30px;
  padding-right: 4px;
  min-height: 50px;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SelectContainer = styled.div`
  width: 30%;
`;

const IconContainer = styled.div`
    svg {
        width: 100%;
        max-height: 15vh;
    }
`;

export { Container, SelectContainer, IconContainer };
